import { PerfKey, perfLogger, PerfTag } from '../../utils/perf';
export function loadAddon() {
    var contextKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PerfKey.root, block = arguments.length > 1 ? arguments[1] : void 0;
    perfLogger.measure(contextKey, PerfTag.addonLoadStart);
    var result = block();
    perfLogger.measure(contextKey, PerfTag.addonLoadEnd);
    return result;
}

//# sourceMappingURL=addon-load.js.map